import { basenameFind, getMetaFromJcamp, getTargetProperty, } from "../common.js";
const differentialScanningCalorimetry = {
    jpath: ['spectra', 'differentialScanningCalorimetry'],
    find: basenameFind,
    getProperty: getTargetProperty,
    process: getMetaFromJcamp,
};
export default differentialScanningCalorimetry;
//# sourceMappingURL=differentialScanningCalorimetry.js.map